import { useGlobalTopOffsetElement } from '@infl-ts/util-global-sticky-offset';
import { ActiveLens, ClearedLens, ErrorStateLens, LoadedLens, LoadingLens } from '@infl-ts/util-lens';
import { Box, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import { absurd } from 'fp-ts/function';
import ToolTip from './active-tooltip';
import ErrorNotification from './error-notification';
import SuccessNotification from './success-notification';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Name = function Name(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_jsx(Typography, {
    variant: "body2",
    component: "span",
    sx: {
      color: function color(theme) {
        return theme.palette.primary.contrastText;
      },
      ml: 0.5,
      fontWeight: 'fontWeightBold'
    },
    "data-element": "Typography",
    "data-component": "Name",
    "data-source-file": "index.tsx",
    children: name
  });
};

var NotificationBar = function NotificationBar(_ref2) {
  var lens = _ref2.lens,
      actions = _ref2.actions;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var theme = useTheme();
  var activeLensBarRef = useGlobalTopOffsetElement();
  if (ClearedLens.is(lens)) return null;
  if (ErrorStateLens.is(lens)) return /*#__PURE__*/_jsx(ErrorNotification, {
    lens: lens,
    actions: actions
  });

  if (LoadingLens.is(lens)) {
    return /*#__PURE__*/_jsx(SuccessNotification, {
      barColour: theme.palette.primary.main,
      linkAction: actions.cancelLens,
      linkText: "Cancel",
      notification: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CircularProgress, {
          color: "inherit",
          size: "12px"
        }), /*#__PURE__*/_jsxs(Typography, {
          variant: "body2",
          sx: {
            ml: 2
          },
          children: ["Loading Lens for", /*#__PURE__*/_jsx(Name, {
            name: lens['impersonated-user'].name
          }), "."]
        })]
      })
    });
  }

  if (LoadedLens.is(lens)) {
    return /*#__PURE__*/_jsx(SuccessNotification, {
      barColour: theme.palette.success.main,
      linkAction: actions.activateLens,
      linkText: "View Lens",
      notification: /*#__PURE__*/_jsxs(Typography, {
        variant: "body2",
        children: ["Lens is ready for", /*#__PURE__*/_jsx(Name, {
          name: lens['impersonated-user'].name
        }), "."]
      })
    });
  }

  if (ActiveLens.is(lens)) {
    return /*#__PURE__*/_jsx(SuccessNotification, {
      ref: activeLensBarRef,
      barColour: theme.palette.accent.main,
      linkAction: actions.refreshLens,
      linkText: "Refresh",
      isActive: true,
      isMobile: isMobile,
      notification: isMobile ? /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'inline-flex',
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsxs(Typography, {
            component: "p",
            variant: "caption",
            children: ["Viewing as", /*#__PURE__*/_jsx(Name, {
              name: lens['impersonated-user'].name
            }), "."]
          }), /*#__PURE__*/_jsx(Typography, {
            component: "p",
            variant: "caption",
            children: lens['loaded-at-with-timezone']
          })]
        }), /*#__PURE__*/_jsx(ToolTip, {})]
      }) : /*#__PURE__*/_jsxs(Typography, {
        variant: "body2",
        component: "span",
        sx: {
          display: 'inline-flex',
          alignItems: 'center'
        },
        children: ["You are looking at a copy of", /*#__PURE__*/_jsx(Name, {
          name: lens['impersonated-user'].name
        }), "'s view as of ", lens['loaded-at-with-timezone'], ".", /*#__PURE__*/_jsx(ToolTip, {})]
      })
    });
  }

  return absurd(lens);
};

export default NotificationBar;